// A helper function to fetch a Skills Academy program.
// Matches the shape returned by useSkillsAcademyProgramDetail so the
// React Query cache entry under ["skills_academy","program",id] can be
// shared between the breadcrumb loader and the page component.

import { useAPI } from "/src/hooks/useAPI";

export async function fetchSkillsAcademyProgram(brand, authToken, programId) {
    const { callAPI } = useAPI();
    try {
        const data = await callAPI(`skills_academy/${programId}`, {
            token: authToken,
        });
        return {
            ...data,
            enrollmentRequestStatus: data.enrollment_request_status ?? null,
        };
    } catch (err) {
        console.error('Error fetching skills academy program:', err.message);
        return null;
    }
}
